import { createSlice, createAction } from "@reduxjs/toolkit";
import listFactory from "./listFactory";
import { UUID } from "../utils";
import User from "../models/User";

const { slicePart, selectors } = listFactory<User>("users");

export const initialState = {
  ...slicePart.initialState,
  currentUser: {
    roles: [],
  },
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
    addItem: slicePart.reducers.addItem,
    updateItem: slicePart.reducers.updateItem,
    removeItem: slicePart.reducers.removeItem,
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
  },
});

export const {
  setList,
  setItem,
  addItem,
  updateItem,
  removeItem,
  setCurrentUser,
} = slice.actions;

export const fetchUsers = createAction("fetchUsers");
export const fetchUser = createAction<{ id: UUID }>("fetchUser");
export const fetchCurrentUser = createAction("fetchCurrentUser");
export const createUser = createAction<{ data: any }>("createUser");
export const updateUser = createAction<{ id: UUID; data: any }>("updateUser");
export const deleteUser = createAction<{ id: UUID }>("deleteUser");
export const setUserActiveFlag = createAction<{ id: UUID; value: boolean }>(
  "setUserActiveFlag"
);

export const { selectList: selectUsers, selectItem: selectUser } = selectors;

export const selectCurrentUser = (state: any) => state.users.currentUser;

export default slice.reducer;
